<template>
    <BaseField v-bind="$props" v-on="$listeners" overflow>
        <div class="d-flex">
            <DatePicker
                :style="{width: inputWidth + 'px'}"
                class="value-field"
                :value="value"
                :dateFormat="dateFormat"
                @update:value="handleUpdateValue"
            />
            <Tooltip
                v-if="['Before', 'After'].includes(comparator)"
                class="tooltip-icon"
                :text="tooltipText"
                :container="false">
                <IconBase iconName="infoTooltipIcon" width="12" height="12" :iconColor="consts.COLORS.LIGHT_700" />
            </Tooltip>
        </div>
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import DatePicker from 'components/datePicker/DatePicker.vue';
import moment from "moment";

export default {
    name: 'DateField',
    components: {
        DatePicker,
        BaseField,
        Tooltip,
        IconBase
    },
    props: {
        ...BaseField.props,
        value: String,
        inputWidth: {
            type: Number,
            default: 130
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD'
        }
    },
    computed: {
        tooltipText() {
            return "Selecting the 'before' or 'after' operator will include only dates prior to or after the "
                + 'selected date. The selected date will not be included';
        },
        consts: () => consts
    },
    methods: {
        handleUpdateValue(date) {
            const value = date instanceof Date ? moment(date).format(this.dateFormat) : date;
            this.$emit('update:value', value);
        }
    }
};
</script>

<style lang="scss" scoped>
.tooltip-icon {
    align-self: flex-start;
    margin-left: 10px;
}
</style>
